const lastLoopStart = {
   previousScheduledTime: null,
   currentScheduledTime: null,
};

export { lastLoopStart };
